import { applianceCategoryMode, EMetaModeGroup } from "@/data/api/kili/programs/program.type";
import { EProgramApplianceCategory, ProgramColorName } from "@/domains/v4b/program/program.types";
import {
  TProgramMetaMode,
  EOnProgramMetaMode,
  EBookableSpaceMetaMode,
  ECommonProgramMetaMode,
  EHeaterProgramMetaMode,
} from "@/domains/v4b/program/subprogram.types";
import { ISystemColor, SYSTEM_COLORS_LIST, SystemColorName } from "@/utils/style-utils";

export function getProgramApplianceCategories(
  defaultCategories: readonly EProgramApplianceCategory[],
  installedCategories: readonly EProgramApplianceCategory[] = [],
  blackListedCategories: readonly EProgramApplianceCategory[] = [],
): EProgramApplianceCategory[] {
  return [...new Set([...defaultCategories, ...installedCategories])].filter(
    (category) => !blackListedCategories.includes(category),
  );
}

export function getMetaModeGroupInstructions(
  applianceCategory: EProgramApplianceCategory,
): Exclude<TProgramMetaMode, "PROGRAMMING">[] {
  const mode = applianceCategoryMode[applianceCategory];

  if (mode === EMetaModeGroup.HEATER_MODE) {
    return [...Object.values(EHeaterProgramMetaMode), ...Object.values(ECommonProgramMetaMode)];
  } else if (mode === EMetaModeGroup.ON_OFF_TEMP_MODE) {
    return [...Object.values(EOnProgramMetaMode), ...Object.values(ECommonProgramMetaMode)];
  } else if (mode === EMetaModeGroup.BOOKABLE_SPACE) {
    return Object.values(EBookableSpaceMetaMode);
  }

  return [...Object.values(EOnProgramMetaMode), ECommonProgramMetaMode.OFF];
}

interface IProgramColor {
  fromColor: string;
  toColor: string;
}

export const PROGRAM_COLORS: Record<ProgramColorName, IProgramColor> = {
  ["BLUE"]: {
    fromColor: "from-primary-400",
    toColor: "to-primary-300",
  },
  ["GREEN"]: {
    fromColor: "from-success-600",
    toColor: "to-success-300",
  },
  ["ORANGE"]: {
    fromColor: "from-warning-600",
    toColor: "to-warning-500",
  },
  ["RED"]: {
    fromColor: "from-error-350",
    toColor: "to-error-300",
  },
  ["PURPLE"]: {
    fromColor: "from-accent-500",
    toColor: "to-accent-300",
  },
};

const ProgramColorNameToSystemColorNameMapping: Record<ProgramColorName, SystemColorName> = {
  ["BLUE"]: "BLUE",
  ["GREEN"]: "EMERALD",
  ["ORANGE"]: "AMBER",
  ["RED"]: "RED",
  ["PURPLE"]: "VIOLET",
};

export function mapProgramColorNameToSystemColor(programColorName: ProgramColorName): ISystemColor {
  return SYSTEM_COLORS_LIST[ProgramColorNameToSystemColorNameMapping[programColorName]];
}
